import React from "react";
import { FormControl } from "@mui/material";
import { MaybeExtended } from "../../../Utils/TypeExtensions";
import { HasValue } from "../../../sharedCode/HelperMethods";
import StringEditor from "../../../Components/inputs/stringEditor";
import DetailPage from "../../../Components/navigation/detailPage";
import { doNothing } from "../../../Components/inputs/inputHelpers";
import { TicketProps } from "../FlightLegs/ticketFlightLegs";
import { YesNoControl } from "../../../Components/YesNoControl";
import { saveTicketChanges } from "../../../Utils/TicketDatabase";
import { FIELD_LIMITS } from "../../../sharedCode/fieldLimits";

export function TicketCustomer(props: TicketProps): JSX.Element {
    return (
        <DetailPage>
            <FormControl fullWidth>
                <StringEditor
                    labelText="CUSTOMER PO NO."
                    initialValue={props.ticket.customer_po}
                    sourceId={props.ticket.id}
                    sourceProperty={"customer_po"}
                    isDisabled={props.isReadOnly}
                    isRequired={false}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    errors={props.errors}
                    containerUrl={"ticket/customer"}
                    maxLength={FIELD_LIMITS.customer_po}
                />
                <YesNoControl
                    sourceId={props.ticket.id}
                    sourceProperty={"is_no_fly"}
                    labelText="DID YOU FLY THE AIRCRAFT TODAY?"
                    initialValue={HasValue(props.ticket.is_no_fly) ? !props.ticket.is_no_fly : null}
                    onChange={handleNoFlyDayChanged}
                    mergeChanges={doNothing}
                    isDisabled={props.isReadOnly}
                    isRequired={true}
                    errors={props.errors}
                    containerUrl={"ticket/customer"}
                />
                <YesNoControl
                    sourceId={props.ticket.id}
                    sourceProperty={"is_per_diems"}
                    labelText="ARE PER DIEMS APPLICABLE?"
                    initialValue={HasValue(props.ticket.is_per_diems) ? Boolean(props.ticket.is_per_diems) : null}
                    onChange={handlePerDiemsChanged}
                    mergeChanges={doNothing}
                    isDisabled={props.isReadOnly}
                    isRequired={true}
                    errors={props.errors}
                    containerUrl={"ticket/customer"}
                />
                <YesNoControl
                    sourceId={props.ticket.id}
                    sourceProperty={"is_other_charges"}
                    labelText="ARE THERE ADDITIONAL CHARGES FOR EQUIPMENT OR PERSONNEL?"
                    initialValue={HasValue(props.ticket.is_other_charges) ? Boolean(props.ticket.is_other_charges) : null}
                    onChange={handleOtherChargesChanged}
                    mergeChanges={doNothing}
                    isDisabled={props.isReadOnly}
                    isRequired={true}
                    errors={props.errors}
                    containerUrl={"ticket/customer"}
                />
                {!props.ticket.is_no_fly && (
                    <YesNoControl
                        sourceId={props.ticket.id}
                        sourceProperty={"any_landings"}
                        labelText="ARE THERE ANY AIRPORT LANDINGS?"
                        initialValue={HasValue(props.ticket.any_landings) ? Boolean(props.ticket.any_landings) : null}
                        onChange={handleLandingsChanged}
                        mergeChanges={doNothing}
                        isDisabled={props.isReadOnly}
                        isRequired={true}
                        errors={props.errors}
                        containerUrl={"ticket/customer"}
                    />
                )}
            </FormControl>
        </DetailPage>
    );

    function handleNoFlyDayChanged(ticketId: number, value: MaybeExtended<boolean>): void {
        // NB - we are reversing the stored value because the question changed
        const is_no_fly = !value ? 1 : 0;
        const any_landings = is_no_fly ? 0 : undefined;
        saveTicketChanges(props.ticket.id, {
            is_no_fly: is_no_fly,
            any_landings: any_landings,
        }).catch(() => props.showForceReloadDialogue());
    }

    function handlePerDiemsChanged(ticketId: number, value: MaybeExtended<boolean>): void {
        const numberResult = value ? 1 : 0;
        saveTicketChanges(props.ticket.id, { is_per_diems: numberResult }).catch(() => props.showForceReloadDialogue());
    }

    function handleOtherChargesChanged(ticketId: number, value: MaybeExtended<boolean>): void {
        const numberResult = value ? 1 : 0;
        saveTicketChanges(props.ticket.id, { is_other_charges: numberResult }).catch(() => props.showForceReloadDialogue());
    }

    function handleLandingsChanged(ticketId: number, value: MaybeExtended<boolean>): void {
        const numberResult = value ? 1 : 0;
        saveTicketChanges(props.ticket.id, { any_landings: numberResult }).catch(() => props.showForceReloadDialogue());
    }
}
